<app-navbar />

<div class="container-fluid">
  <div class="card">
    <div class="conteudo">
      <h4>Cadastro de Usuário</h4>
      <p>Preencha o formulário para incluir um novo usuário.</p>
      <div class="linha"></div>
    </div>

    <div class="card-body">
      <form [formGroup]="formulario" enctype="multipart/form-data" (ngSubmit)="onSubmit()">
        <div class="row gy-4">
          <div class="col-md-6">
            <label for="nome" class="form-label">Nome completo</label>
            <input id="nome" type="text" class="form-control" formControlName="nome"
              placeholder="Ex: João Gomes da Silva" />
            <div class="text-danger" *ngIf="f['nome'].touched && f['nome'].invalid">
              Informe o nome completo com pelo menos 8 caracteres.
            </div>
          </div>

          <div class="col-md-6">
            <label for="nomeusuario" class="form-label">Nome do usuário</label>
            <input id="nomeusuario" type="text" class="form-control" formControlName="userName"
              placeholder="Ex: joaogomes" />
            <div class="text-danger" *ngIf="f['userName'].touched && f['userName'].invalid">
              Nome de usuário com pelo menos 4 caracteres.
            </div>
          </div>

          <div class="col-md-5">
            <label for="cpf" class="form-label">CPF</label>
            <input id="cpf" type="text" class="form-control" formControlName="cpf" mask="000.000.000-00"
              placeholder="Ex: 111.111.111-11" />
            <div class="text-danger" *ngIf="f['cpf'].touched && f['cpf'].invalid">
              CPF com 11 dígitos. Ex: 12345678900
            </div>
          </div>

          <div class="col-md-7">
            <label for="email" class="form-label">E-mail</label>
            <input id="email" type="email" class="form-control" formControlName="email"
              placeholder="Ex: joaogomes@gmail.com" />
            <div class="text-danger" *ngIf="f['email'].touched && f['email'].invalid">
              <span *ngIf="f['email'].errors?.['email']">E-mail inválido.</span>
            </div>
          </div>

          <div class="col-md-4">
            <label for="empresaId" class="form-label">Empresa</label>
            <select id="empresaId" class="form-select" formControlName="empresaId">
              <option value="" disabled selected>Selecione uma empresa</option>
              <option *ngFor="let empresa of empresas" [value]="empresa.empresaId">
                {{ empresa.nomeDaEmpresa }}
              </option>
            </select>
            <div class="text-danger mt-1" *ngIf="f['empresaId'].touched && f['empresaId'].invalid">
              Selecione uma empresa.
            </div>
            <div class="text-muted mt-1" *ngIf="carregandoEmpresas">Carregando empresas...</div>
            <div class="text-danger mt-1" *ngIf="erroCarregarEmpresas">{{ erroCarregarEmpresas }}</div>
          </div>

          <div class="col-md-4">
            <label for="role" class="form-label">Perfil</label>
            <select id="role" class="form-select" formControlName="role">
              <option value="" disabled selected>Selecione o perfil</option>
              <option *ngFor="let perfil of perfis" [value]="perfil.value">
                {{ perfil.label }}
              </option>
            </select>
            <div class="text-danger mt-1" *ngIf="f['role'].touched && f['role'].invalid">
              Selecione o perfil do usuário.
            </div>
          </div>

          <div class="col-md-4">
            <label for="password" class="form-label">Senha</label>
            <div class="input-group">
              <input [type]="senhaVisivel ? 'text' : 'password'" id="password" class="form-control"
                formControlName="senha" placeholder="Digite a senha" autocomplete="new-password" />
              <button class="btn btn-outline-secondary" type="button" (click)="toggleSenhaVisivel()">
                <i class="bi" [class]="senhaVisivel ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            <div class="text-danger" *ngIf="f['senha'].touched && f['senha'].invalid">
              <span *ngIf="f['senha'].errors?.['required']">Senha é obrigatória.</span>
              <span *ngIf="f['senha'].errors?.['minlength']">Senha deve ter pelo menos 8 caracteres.</span>
              <span *ngIf="f['senha'].errors?.['pattern']">Use letras maiúsculas, minúsculas, números e símbolos.</span>
            </div>
          </div>

          <div class="col-md-12">
            <label for="password-confirm" class="form-label">Confirme a senha</label>
            <div class="input-group">
              <input [type]="senhaConfirmacaoVisivel ? 'text' : 'password'" id="password-confirm" class="form-control"
                formControlName="senhaConfirmacao" placeholder="Confirme sua senha" autocomplete="new-password" />
              <button class="btn btn-outline-secondary" type="button" (click)="toggleSenhaConfirmacaoVisivel()">
                <i class="bi" [class]="senhaConfirmacaoVisivel ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>
            <div class="text-danger" *ngIf="f['senhaConfirmacao'].touched && f['senhaConfirmacao'].invalid">
              As senhas devem ser iguais.
            </div>
          </div>

          <!-- FOTO -->
          <div class="col-md-12">
            <label class="form-label">Foto de Perfil</label>
            <div class="d-flex justify-content-center gap-3">
              <button type="button" class="btn btn-outline-primary rounded-pill px-4" (click)="abrirCameraModal()">
                <i class="bi bi-camera-fill me-1"></i> Tirar Foto
              </button>
              <button type="button" class="btn btn-outline-secondary rounded-pill px-4" (click)="abrirFilePicker()">
                <i class="bi bi-upload me-1"></i> Selecionar
              </button>
              <!-- Input de arquivo oculto, mas sempre presente na página -->
              <input type="file" class="d-none" #fileInput (change)="onFileChange($event)" accept="image/*" />
            </div>
            <div *ngIf="fotoPreview" class="text-center mt-3">
              <img [src]="fotoPreview" class="img-thumbnail shadow" style="max-width: 150px;" />
            </div>
          </div>
        </div>

        <!-- BOTÕES -->
        <div class="mt-4 d-flex justify-content-center gap-3">
          <input type="submit" class="btn btn-success" value="Cadastrar" />
          <button type="button" class="btn btn-danger" (click)="cancelar()">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- MODAL BONITO DA CÂMERA -->
<div class="modern-modal-backdrop" *ngIf="cameraModalAberto">
  <div class="modern-modal">
    <h5 class="mb-3">Capturar Foto</h5>
    <video #video autoplay playsinline></video>
    <canvas #canvas hidden></canvas>

    <div class="d-flex justify-content-center gap-3 mt-4">
      <button class="btn btn-success" (click)="capturarFoto()">
        <i class="bi bi-check-circle"></i> Capturar
      </button>
      <button class="btn btn-danger" (click)="fecharCameraModal()">
        <i class="bi bi-x-circle"></i> Cancelar
      </button>
    </div>
  </div>
</div>